import { getMembersZendeskHealthcheckUrl } from "@/constants/zendesk-urls/members-healthcheck-urls";
import { membersZendeskSsoLink } from "@/server/models/zendesk/zendesk-sso-link";
import Link from "next/link";

export const NoResultsContent = ({ fiscalYear }: { fiscalYear: number }) => {
  return (
    <div className="flex w-full flex-col items-center gap-10 pt-10">
      <div className="text-center text-sm whitespace-pre-wrap text-monotone-6">
        {
          "お探しの施設が見つかりませんでした。条件を広げて検索いただくか、別の地域をお試しください。\n\nまた、どうしてもご自宅やお勤め先の近くに契約健診機関がない場合は、\n「"
        }
        <Link
          href={membersZendeskSsoLink(
            getMembersZendeskHealthcheckUrl(
              "ご自宅の近くに契約健診機関がない場合について",
              fiscalYear,
            ),
          )}
          className="text-primary-6 underline"
          target="_blank"
          rel="noopener noreferrer"
          prefetch={false}
        >
          {`${fiscalYear}年度、契約外の健診機関を利用される方へ`}
        </Link>
        {"」をご確認ください。"}
      </div>
    </div>
  );
};
